import { ICompanyGridProps } from '../types'
import { CompanyCard } from './company-card'

export const CompanyGrid = ({
  companies,
  onSelect,
}: ICompanyGridProps): JSX.Element => (
  <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
    {companies.map(company => (
      <div key={company.id} className="flex justify-center">
        <CompanyCard company={company} onSelect={onSelect} />
      </div>
    ))}
  </div>
)
